import { HTMLAttributes } from 'react';

interface ContentProps extends HTMLAttributes<HTMLDivElement> {
    withoutInner?: boolean,
    children?: React.ReactNode,
}

function Content({withoutInner, ...props}: ContentProps) {
    const { children } = props;
    return (
        <div {...props} className="content">
            {withoutInner ?
                <>
                    {children}
                </>
                :
                <div className="content__inner">
                    {children}
                </div>
            }
        </div>
    );
}

export default Content;
